import React, {useEffect, useState} from 'react';
import ProductImageSmall from "../product-upload/product-image-small";
import _ from "lodash";
import {searchProducts} from "../../services/product-data-service";
import ProductFilters from "./product-filters";

const ProductList = ({podDetail}) => {
    const [initialStep, setInitialStep] = useState(true);
    const [productsList, setProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(null);

    useEffect(() => {
        if (initialStep) {
            searchProductsList();
        }
    }, [initialStep]);

    const searchProductsList = async () => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: podDetail?.id});

        // console.log('filterCriteria: ', filterCriteria)

        _.forIn(filterCriteria, (value, field) => {
            if (!_.isEmpty(value)) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        const existingProducts = await searchProducts(searchCriteriaList);
        setProductsList(existingProducts);
    }

    return (
        <>

            <div className="-ml-2 mb-6">
                <ProductFilters
                    searchProductsList={searchProductsList}
                    filterCriteria={filterCriteria}
                    setFilterCriteria={setFilterCriteria}
                    clearFilterCriteria={undefined}
                    podDetail={podDetail}
                    hideColorsAndSizes={false}/>
            </div>

            <div className="table-container overflow-y-scroll border-y border-gray-400 bg-white">
                <table className="w-full">
                    <thead className="">
                    <tr>
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Parent
                            Product
                        </th>
                        {podDetail?.productFieldMapping?.map((productField, rowIndex) => (
                            <th key={`th-${rowIndex}`}
                                className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{productField?.label}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody className="">
                    {productsList?.map((product, rowIndex) => (
                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                            <td className="p-2 border border-gray-400 m-auto">
                                <div>{product?.parent}</div>
                            </td>
                            {podDetail?.productFieldMapping?.map((productField, columnIndex) => (
                                <td key={`column-${rowIndex}-${columnIndex}`}
                                    className="p-2 border border-gray-400 m-auto">

                                    {productField.attribute === 'image' &&
                                        <div>
                                            <ProductImageSmall imageUrl={product[productField.attribute]}/>
                                        </div>
                                    }

                                    {productField.attribute !== 'image' &&
                                        <>{product[productField.attribute]}</>
                                    }

                                </td>
                            ))}
                        </tr>

                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default ProductList
